import { useCreditPricing, formatCredits } from '../../hooks/useCreditPricing';

interface Props {
  // Feature de conexão: conn_whatsapp_unofficial | conn_marketplace | conn_social_official
  featureKey: string;
  className?: string;
}

/**
 * Aviso de mensalidade de uma conexão, exibido no fluxo de conectar.
 * Só aparece quando a cobrança recorrente de conexões está ATIVA no backend
 * (CONNECTION_BILLING_ENABLED) — evita mostrar cobrança que ainda não ocorre.
 */
export function ConnectionCostNotice({ featureKey, className }: Props) {
  const { getMeta, loading, connectionBillingEnabled } = useCreditPricing();
  if (loading || !connectionBillingEnabled) return null;
  const meta = getMeta(featureKey);
  if (!meta) return null;

  return (
    <div className={`rounded-xl border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs text-amber-800 ${className || ''}`}>
      <div className="flex items-start gap-2">
        <span className="text-sm leading-none">⚡</span>
        <p>
          Esta conexão consome <span className="font-bold">{formatCredits(meta.cost)} créditos/mês</span>,
          cobrados na ativação e renovados mensalmente. Sem saldo na renovação, a conexão é desativada.
        </p>
      </div>
    </div>
  );
}
